import { render, staticRenderFns } from "./UserGroupList.vue?vue&type=template&id=135b2e2b&scoped=true"
import script from "./UserGroupList.vue?vue&type=script&lang=js"
export * from "./UserGroupList.vue?vue&type=script&lang=js"
import style0 from "./UserGroupList.vue?vue&type=style&index=0&id=135b2e2b&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "135b2e2b",
  null
  
)

export default component.exports